import { axios } from "~/plugins/request";
export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findAllType({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/findAllType`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveType({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/dictionary/saveType`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteTypeById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/deleteTypeById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findTypeById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/findTypeById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAllItemByTypeCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/findAllItemByTypeCode`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAllItemByTypeCodeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/dictionary/findAllItemByTypeCodeList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  saveItem({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/dictionary/saveItem`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findItemById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/findItemById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteItemById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/deleteItemById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
